import { ThemeProvider as AWSThemeProvider } from "@aws-amplify/ui-react";
import { Authenticator } from "@aws-amplify/ui-react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Amplify } from "aws-amplify";
import gtag from "ga-gtag";
import { SnackbarProvider } from "notistack";

import UserSettingsDialog from "./components/dialogs/userSettingsDialog";
import DemoCUPortal from "./components/portals/demoCUPortal.js";
import GotSoccerPortal from "./components/portals/gotSoccerPortal.js";
import OnboardingPortal from "./components/portals/onboardingPortal";
import SheHubPortal from "./components/portals/sheHubPortal.js";
import SportsPortal from "./components/portals/sportsPortal.js";
import UnsubscribePortal from "./components/portals/unsubscribePortal";
import { components, getFormFields } from "./components/ui/amplify/loginComponents";
import OmniSnackBar from "./components/ui/omniSnackbar";

import { awsTheme } from "./assets/awsTheme";
import constants from "./assets/constants";
import { themeDefinitions } from "./assets/mui5themes";
import awsconfig from "./awsConfig";
import getHyperbaricOrganizationPortal from "./hyperbaricOrganizationPortal";
import getBotpressOrganizationPortal from "./omniBotpressPortal.js";
import getOmniOrganizationPortal from "./omniOrganizationPortal";
import * as UserSessionActions from "./state/redux/userSession";

import "./App.css";

Amplify.configure(awsconfig);

const getUserPortal = (awsGroup, organizationODM) => {
  //todo Rework this to guard EVERYTHING against the Org not being loaded?d
  if (organizationODM != null && awsGroup != null) {
    // Depricating this on 2.10.26 -AK trying to clean up the package includes, these two client portals
    // now default to our default org,
    // if (organizationODM.omniData.organizationType === constants.organizationTypeEnums.empireOS) {
    //   return getEmpireOrganizationPortal(awsGroup);
    // } else if (
    //   organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
    // ) {
    //   return getNsightOrganizationPortal(awsGroup);
    // } else
    if (organizationODM.omniData.organizationType === constants.organizationTypeEnums.hyperbaric) {
      return getHyperbaricOrganizationPortal(awsGroup);
    } else if (
      organizationODM.omniData.organizationType === constants.organizationTypeEnums.botpressTesting
    ) {
      return getBotpressOrganizationPortal(awsGroup);
    } else {
      return getOmniOrganizationPortal(awsGroup);
    }
  } else if (awsGroup === constants.userGroups.Creator) {
    return getOmniOrganizationPortal(awsGroup);
  }
};

const App = props => {
  const {
    setAwsUserRequest,
    loadUserODMRequest,
    loadUserToDosRequest,
    awsGroup,
    themeId,
    organizationODM,
  } = props;

  const { user } = useAuthenticator(context => [context.user]);
  const loginMethod = "cognito";

  const myLocation = useLocation();
  // One stop shop for our omni_page_views
  // Grab that location
  // tag it and bag it
  useEffect(() => {
    gtag("event", "omni_page_view", {
      omni_page_title: `${myLocation.pathname}`,
      omni_page_location: `${window.location}`,
    });
  }, [myLocation.pathname]);

  useEffect(() => {
    if (user) {
      setAwsUserRequest(user);
      loadUserODMRequest(user.attributes["custom:userId"]);
      loadUserToDosRequest();
      gtag("event", "login", { method: `${loginMethod}` });
    }
  }, [user, setAwsUserRequest, loadUserODMRequest, loadUserToDosRequest]);

  const [userNameQP, setUserNameQP] = useState(null);
  const [resetPasswordQP, setResetPasswordQP] = useState(null);

  useEffect(() => {
    // const userName = "userName";
    const urlParams = new URLSearchParams(window.location.search);
    const paramVal = urlParams.get("userName");
    if (paramVal) {
      setUserNameQP(paramVal);
    }
  }, [userNameQP]);

  useEffect(() => {
    if (!resetPasswordQP) {
      const urlParams = new URLSearchParams(window.location.search);
      const paramVal = urlParams.get("resetPassword");
      if (paramVal) {
        setResetPasswordQP("resetPassword");
      }
    }
  }, [resetPasswordQP]);

  const currentRoute = window.location.pathname;

  const calculateThemeId = (theId, theRoute) => {
    if (theRoute === constants.appPaths.appPathDemoSchoolsFirst) {
      return 3;
    }
    return theId;
  };
  const [calculatedThemeId] = useState(calculateThemeId(themeId, currentRoute));

  if (
    currentRoute === constants.appPaths.appPathOnboarding ||
    currentRoute === constants.appPaths.appPathUnsubscribe
  ) {
    //onboarding path, skip Authorization
    return (
      <AWSThemeProvider theme={awsTheme(calculatedThemeId)}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={createTheme(themeDefinitions[calculatedThemeId])}>
                <Switch>
                  <Route exact path={constants.appPaths.appPathOnboarding}>
                    <OnboardingPortal />
                  </Route>
                  <Route exact path={constants.appPaths.appPathUnsubscribe}>
                    <UnsubscribePortal />
                  </Route>
                  <Route render={() => <Redirect to={constants.appPaths.appPathOnboarding} />} />
                </Switch>
              </ThemeProvider>
            </StyledEngineProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </AWSThemeProvider>
    );
  }

  //This is publiclly accessible for demoing purposes
  if (
    (currentRoute === constants.appPaths.appPathHarness ||
      currentRoute === constants.appPaths.appPathMahalo ||
      currentRoute === constants.appPaths.appPathSheHub ||
      currentRoute === constants.appPaths.appPathGotSoccer ||
      currentRoute === constants.appPaths.appPathDemoSchoolsFirst ||
      currentRoute === constants.appPaths.appPathAvatar) &&
    (window.location.hostname.includes("dev") ||
      window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("test"))
  ) {
    //bot test, skip Authorization
    return (
      <AWSThemeProvider theme={awsTheme(calculatedThemeId)}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={createTheme(themeDefinitions[calculatedThemeId])}>
                <Switch>
                  <Route exact path={constants.appPaths.appPathAvatar}>
                    <SportsPortal />
                  </Route>
                  <Route exact path={constants.appPaths.appPathGotSoccer}>
                    <GotSoccerPortal />
                  </Route>
                  <Route exact path={constants.appPaths.appPathSheHub}>
                    <SheHubPortal />
                  </Route>
                  <Route exact path={constants.appPaths.appPathDemoSchoolsFirst}>
                    <DemoCUPortal />
                  </Route>
                  <Route render={() => <Redirect to={constants.appPaths.appPathAvatar} />} />
                </Switch>
              </ThemeProvider>
            </StyledEngineProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </AWSThemeProvider>
    );
  }

  return (
    <AWSThemeProvider theme={awsTheme(calculatedThemeId)}>
      <Authenticator
        formFields={getFormFields(userNameQP)}
        components={components}
        hideSignUp={true}
        initialState={resetPasswordQP}
      >
        {({ signOut }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              transitionDuration={{ enter: 500, exit: 250 }}
              autoHideDuration={2500}
              Components={{
                default: OmniSnackBar,
                error: OmniSnackBar,
                success: OmniSnackBar,
                warning: OmniSnackBar,
                info: OmniSnackBar,
              }}
            >
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={createTheme(themeDefinitions[calculatedThemeId])}>
                  {((organizationODM != null && awsGroup != null) ||
                    awsGroup === constants.userGroups.Creator) &&
                    getUserPortal(awsGroup, organizationODM)}

                  <UserSettingsDialog />
                </ThemeProvider>
              </StyledEngineProvider>
            </SnackbarProvider>
          </LocalizationProvider>
        )}
      </Authenticator>
    </AWSThemeProvider>
  );
};

const mapStateToProps = state => ({
  themeId: state.userSession.themeId,
  awsUser: state.userSession.awsUser,
  awsAuth: state.userSession.awsAuth,
  awsGroup: state.userSession.awsGroup,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  setAwsUserRequest: UserSessionActions.setAwsUserRequest,
  loadUserODMRequest: UserSessionActions.loadUserODMRequest,
  loadUserToDosRequest: UserSessionActions.loadUserToDosRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
